import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "breadcrumb-tabs mb-6"
};
var _hoisted_2 = {
  "class": "w-full flex justify-between items-center"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  "class": "w-1/3 bg-indigo-800 tabWidth p-2 px-4",
  as: "button"
}, [/*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm font-bold text-white"
}, " Research Data ")], -1);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm font-bold text-ftext"
}, " Data Breakup ", -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm font-bold text-ftext"
}, " Lead Conversions ", -1);
var _hoisted_6 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Account")])], -1);
var _hoisted_8 = {
  "class": "px-6"
};
var _hoisted_9 = ["value"];
var _hoisted_10 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Start Date")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "End Date")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Member")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Campaign")])], -1);
var _hoisted_11 = {
  "class": "px-6 pb-4"
};
var _hoisted_12 = {
  "class": "px-6 pb-4"
};
var _hoisted_13 = {
  "class": "px-6 pb-4"
};
var _hoisted_14 = ["value"];
var _hoisted_15 = {
  "class": "px-6 pb-4"
};
var _hoisted_16 = ["value"];
var _hoisted_17 = {
  "class": "px-6 pb-4"
};
var _hoisted_18 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_19 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Contacts"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6"
}, "Companies"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6"
}, "New Companies")])], -1);
var _hoisted_21 = {
  "class": "hover:bg-gray-100 focus-within:bg-gray-100"
};
var _hoisted_22 = {
  "class": "border-t"
};
var _hoisted_23 = {
  "class": "flex items-center px-6 py-4 focus:text-indigo-500"
};
var _hoisted_24 = {
  "class": "border-t"
};
var _hoisted_25 = {
  tabindex: "-1",
  "class": "flex items-center px-6 py-4 focus:text-indigo-500"
};
var _hoisted_26 = {
  "class": "border-t"
};
var _hoisted_27 = {
  tabindex: "-1",
  "class": "flex items-center px-6 py-4 focus:text-indigo-500"
};
var _hoisted_28 = {
  key: 0
};
var _hoisted_29 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "4"
}, "No Data found.", -1);
var _hoisted_30 = [_hoisted_29];
var _hoisted_31 = {
  "class": "flex items-center mb-6"
};
var _hoisted_32 = /*#__PURE__*/_createElementVNode("option", {
  value: "department"
}, "Department", -1);
var _hoisted_33 = /*#__PURE__*/_createElementVNode("option", {
  value: "title"
}, "Title", -1);
var _hoisted_34 = /*#__PURE__*/_createElementVNode("option", {
  value: "industry"
}, "Industry", -1);
var _hoisted_35 = /*#__PURE__*/_createElementVNode("option", {
  value: "sub_industry"
}, "Sub Industry", -1);
var _hoisted_36 = [_hoisted_32, _hoisted_33, _hoisted_34, _hoisted_35];
var _hoisted_37 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_38 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_39 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6"
}, "Count")])], -1);
var _hoisted_40 = {
  "class": "hover:bg-gray-100 focus-within:bg-gray-100"
};
var _hoisted_41 = {
  "class": "border-t"
};
var _hoisted_42 = {
  "class": "flex items-center px-6 py-4 focus:text-indigo-500"
};
var _hoisted_43 = {
  "class": "border-t"
};
var _hoisted_44 = {
  tabindex: "-1",
  "class": "flex items-center py-4 focus:text-indigo-500"
};
var _hoisted_45 = {
  key: 0
};
var _hoisted_46 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "4"
}, "No Data found.", -1);
var _hoisted_47 = [_hoisted_46];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Link = _resolveComponent("Link");
  var _component_Head = _resolveComponent("Head");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_Link, {
    href: "/tenant/parameter",
    "class": "w-1/3 bg-white tabWidth p-2 px-4",
    as: "button"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  }), _createVNode(_component_Link, {
    href: "/tenant/solution",
    "class": "w-1/3 bg-white tabWidth p-2 px-4",
    as: "button"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_5];
    }),
    _: 1
  })])]), _createElementVNode("div", null, [_createVNode(_component_Head, {
    title: "Research Data"
  }), _createElementVNode("table", _hoisted_6, [_hoisted_7, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_8, [_withDirectives(_createElementVNode("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.tenant = $event;
    }),
    "class": "form-select w-40"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.internalTenants, function (tenant, tenant_key) {
    return _openBlock(), _createElementBlock("option", {
      value: tenant.id
    }, _toDisplayString(tenant.id), 9, _hoisted_9);
  }), 256))], 512), [[_vModelSelect, $data.form.tenant]])])]), _hoisted_10, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_11, [_withDirectives(_createElementVNode("input", {
    type: "date",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.form.start_date = $event;
    }),
    "class": "form-select mt-1 w-40"
  }, null, 512), [[_vModelText, $data.form.start_date]])]), _createElementVNode("td", _hoisted_12, [_withDirectives(_createElementVNode("input", {
    type: "date",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.end_date = $event;
    }),
    "class": "ml-2 form-select mt-1 w-40"
  }, null, 512), [[_vModelText, $data.form.end_date]])]), _createElementVNode("td", _hoisted_13, [_withDirectives(_createElementVNode("select", {
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return $data.form.member = $event;
    }),
    "class": "ml-2 form-select mt-1 w-40"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenant_details.members, function (member, index) {
    return _openBlock(), _createElementBlock("option", {
      value: member.id
    }, _toDisplayString(member.name), 9, _hoisted_14);
  }), 256))], 512), [[_vModelSelect, $data.form.member]])]), _createElementVNode("td", _hoisted_15, [_withDirectives(_createElementVNode("select", {
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.campaign = $event;
    }),
    "class": "ml-2 form-select mt-1 w-40"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenant_details.campaigns, function (campaign, key) {
    return _openBlock(), _createElementBlock("option", {
      value: campaign.id
    }, _toDisplayString(campaign.name), 9, _hoisted_16);
  }), 256))], 512), [[_vModelSelect, $data.form.campaign]])]), _createElementVNode("td", _hoisted_17, [_createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 rounded-md",
    type: "button",
    onClick: _cache[5] || (_cache[5] = function () {
      return $options.reset && $options.reset.apply($options, arguments);
    })
  }, "Reset")])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("table", _hoisted_19, [_hoisted_20, _createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_21, [_createElementVNode("td", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString($props.tenant_details.contacts), 1)]), _createElementVNode("td", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString($props.tenant_details.companies), 1)]), _createElementVNode("td", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString($props.tenant_details.distinctCompanies), 1)])]), $props.tenant_details.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_28, _hoisted_30)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_31, [_withDirectives(_createElementVNode("select", {
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.selected_field = $event;
    }),
    "class": "form-select mt-10 w-40"
  }, _hoisted_36, 512), [[_vModelSelect, $data.selected_field]])]), _createElementVNode("div", _hoisted_37, [_createElementVNode("table", _hoisted_38, [_hoisted_39, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenant_details[$data.selected_field], function (industry, industry_key) {
    return _openBlock(), _createElementBlock("tr", _hoisted_40, [_createElementVNode("td", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(industry.name), 1)]), _createElementVNode("td", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(industry.contact_count), 1)])]);
  }), 256)), $props.tenant_details.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_45, _hoisted_47)) : _createCommentVNode("", true)])])])])], 64);
}